const ToggleSwitch = ({
  label,
  checked = false,
  onChange,
  disabled = false,
}) => {
  return (
    <label className="app-toggle-field">
      <button
        type="button"
        role="switch"
        aria-checked={
          checked
        }
        className={`app-toggle ${
          checked
            ? "active"
            : ""
        }`}
        onClick={() =>
          !disabled &&
          onChange?.(
            !checked
          )
        }
        disabled={
          disabled
        }
      >
        <span />
      </button>

      <span>
        {label}
      </span>
    </label>
  );
};

export default ToggleSwitch;